var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{style:({ color: _vm.color, backgroundColor: _vm.bgColor }),attrs:{"bottom":40,"right":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }